import angular from 'angular';

import './option-select.style.sass';
import template from './option-select.tpl.pug';

class OptionSelectController {
    /* @ngInject */
    constructor(arrayUtil) {
        this.arrayUtil = arrayUtil;
    }

    $onInit() {
        this.$ctrl.$formatters.push(this.formatter.bind(this));
        this.$ctrl.$parsers.push(this.parser.bind(this));
    }

    $onChanges(changeObject) {
        if (changeObject.options) {
            this.options = this.createOptions(changeObject.options.currentValue);
        }
        if (changeObject.id) {
            this.id = changeObject.id.currentValue;
        }
    }

    formatter(id) {
        let option = this.arrayUtil.find(this.options, (option) => option.empty || option.id === id);
        return option.value;
    }

    parser(value) {
        let option = this.arrayUtil.find(this.options, (option) => option.empty || option.value === value);
        return option.id;
    }

    getIndexById(id) {
        return this.arrayUtil.find(this.options, (option) => option.empty || option.id === id, -1, (option, index) => index);
    }

    createOptions(options) {
        options = options || [];

        if (options.length > 0) {
            return options.map((option) => {
                if (typeof option !== 'object') {
                    option = {
                        id: option,
                        value: option
                    };
                }

                return angular.merge({}, option);
            });
        }

        return [
            { empty: true, value: '-' }
        ];
    }

    selectPreviousOption() {
        let index = this.getIndexById(this.$ctrl.$modelValue);
        this.update(this.options[index > 0 ? index - 1 : this.options.length - 1]);
    }

    selectNextOption() {
        let index = this.getIndexById(this.$ctrl.$modelValue);
        this.update(this.options[(index + 1) % this.options.length]);
    }

    update(option) {
        this.$ctrl.$setViewValue(option.value);
        this.$ctrl.$render();
    }
}

export default {
    selector: 'dbAOptionSelect',
    template: template(),
    controller: OptionSelectController,
    require: {
        $ctrl: 'ngModel'
    },
    bindings: {
        id: '<ngModel',
        options: '<',
        disabled: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/option-select/option-select.cmpt.js